import React, { Suspense } from 'react';
import { AddinFilter } from "../../components/Filter/AddinFilter";

require("../../utils/Settings");
require("../../utils/Paths");
require("../../utils/Globals");
require("../../utils/Languages");
require("../../utils/Search-Params");
require("../../modules/cookie/cookie");

function App() {
    return (
        <Suspense fallback={<div></div>}>
            <div className="main" style={{ paddingBottom: "30px" }}>
                <AddinFilter />
            </div> 
        </Suspense>
    );
}

export default App;